module.exports = __webpack_public_path__ + "fonts/Prompt-Bold.befa1f27.ttf";